import React, { FC, PropsWithChildren } from "react";
import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { Avatar } from "../Avatar";
import "./ChatMessagePart.scss";

export interface ChatMessagePartProps {
    readonly showAvatar: boolean;
    readonly user: ChatUserInfo;
}

function renderAvatar(entity: ChatUserInfo) {
    return (
        <div className="xappw-chat-msg-part__avatar">
            <Avatar entity={entity} />
        </div>
    );
}

export const ChatMessagePart: FC<PropsWithChildren<ChatMessagePartProps>> = props => {
    return (
        <div className="xappw-chat-msg-part">
            {props.showAvatar && renderAvatar(props.user)}
            {props.children}
        </div>
    );
};

